import { BaseModel } from './BaseModel';

export class RustServerImage extends BaseModel {
    public id = -1;
    public type = '';
    public sha256 = '';
    public ext = '';
    public createdAt = '';
    public updatedAt = '';

    getRouteName() {
        return 'rust_server_image';
    }

    getRouteID() {
        return this.id.toString();
    }
}
